import React from 'react';
import RunningGuy from './RunningGuy';

class IOSPreviousDecline extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getWhiteLabelKey(){    
        if(window.COMPANY_ID != undefined){
            return window.COMPANY_ID;
        }
        else {
            return 0;
        }
    }

    appName = () => {
        switch(this.getWhiteLabelKey()){
            case 1:
                return 'Medefy ';
            case 6:
                return 'HealthChoice ';
            default:
                return ''
        }
    }

    render() {
        return (
            <div className={'container'}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
                    <div style={{ maxWidth: '90%', margin: '0 5%' }}>
                        <br /><RunningGuy />
                    </div>
                    <div style={{ padding: '0 25px 0 25px' }} className={'grey-font'}>
                        <div style={{paddingTop:10, paddingBottom:10}}>
                            <span className={'activity-tracker-permissions-header'}>Track your steps and earn digital badges!</span>
                        </div>
                        <div className={'activity-tracker-permissions-description'} style={{textAlign: 'left' }}>
                            <span className={'activity-tracker-permissions-description'}>Unable to request permissions, you may have previously declined access to retrieve the needed information. To manually enable permissions.</span>
                            <ol className={'activity-tracker-permissions-description-li'}>
                                <li >Open setting on your iPhone</li>
                                <li >Select "Health"</li>
                                <li >Select "Data Access & Devices</li>
                                <li >{`Select the ${this.appName()}App`}</li>
                                <li >Toggle Read & Write for Steps "ON"</li>
                                <li >{`Return to the ${this.appName()}app and try again`}</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        )
    }
}

export default IOSPreviousDecline;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/IOSPreviousDecline.js